import { ButtonFilled } from '@snack-uikit/button';

type CTAButtonProps = {
  title: string;
  link: string;
  onClick: (link: string) => void;
};

export function CTAButton(props: CTAButtonProps) {
  const { title, link, onClick } = props;

  const handleClick = () => onClick(link);

  return (
    <ButtonFilled
      label={title}
      size="m"
      onClick={handleClick}
      data-test-id="cta-button"
    />
  );
}
